import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  referee: null,
  refereeStatus: null,
  canEdit: null,
  daysLeft: null,
};

const refereeSlice = createSlice({
  name: "referee",
  initialState,
  reducers: {
    setReferee: (state, { payload }) => {
      state.referee = payload;
    },
    setRefereeStatus: (state, { payload }) => {
      state.refereeStatus = payload;
    },
    setCanEdit: (state, { payload }) => {
      state.canEdit = payload;
    },
    setDaysLeft:(state, { payload }) => {
      state.daysLeft = payload;
    },
  },
});
const { actions, reducer } = refereeSlice;

export const { setReferee, setRefereeStatus, setCanEdit,setDaysLeft } = actions;
export default reducer;

// selectors
export const refereeSelector = (state) => state.referee.referee;
export const daysLeftSelector = (state) => state.referee.daysLeft;
export const refereeStatusSelector = (state) => state.referee.refereeStatus;
export const canEditSelector = (state) => state.referee.canEdit;
